// Generated from packages/tokens/tokens.json by packages/tokens/generate.mjs. Do not edit.
export const ICONS: Record<string, string> = {
  "inbox": "M4 13h4l1.5 2.5h5L16 13h4M5.5 6.5 4 13v5.5h16V13l-1.5-6.5z",
  "clock": "M12 7v5l3 2M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18z",
  "plus": "M12 5v14M5 12h14",
  "search": "M11 18a7 7 0 1 1 0-14 7 7 0 0 1 0 14zM20 20l-4-4",
  "sidebar": "M4 5h16v14H4zM9.5 5v14",
  "listpane": "M4 6h7M4 10h7M4 14h7M4 18h7M14 5h6v14h-6z",
  "chevR": "m9 6 6 6-6 6",
  "chevL": "m15 6-6 6 6 6",
  "chevD": "m6 9 6 6 6-6",
  "arrowL": "M19 12H5M11 6l-6 6 6 6",
  "arrowU": "M12 19V5M6 11l6-6 6 6",
  "arrowD": "M12 5v14M6 13l6 6 6-6",
  "check": "M5 12.5 10 17.5 19 7",
  "checks": "M2.5 12.5 7 17 16 7M11 16l1 1 9.5-10",
  "circle": "M12 20.5a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17z",
  "circleDot": "M12 20.5a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17zM12 14.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z",
  "bookmark": "M7 4h10v16l-5-3.5L7 20z",
  "hash": "M10 4 8 20M16 4l-2 16M5 9h15M4 15h15",
  "contents": "M9 6h11M9 12h11M13 18h7M4.5 6h.01M4.5 12h.01M8.5 18h.01",
  "comment": "M6 4.5h12A2.5 2.5 0 0 1 20.5 7v7.5a2.5 2.5 0 0 1-2.5 2.5h-6l-4.5 3.5V17H6a2.5 2.5 0 0 1-2.5-2.5V7A2.5 2.5 0 0 1 6 4.5z",
  "bookmarkF": "M7 4h10v16l-5-3.5L7 20z",
  "ext": "M14 5h5v5M19 5l-8 8M18 14v4.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 4 18.5v-11A1.5 1.5 0 0 1 5.5 6H10",
  "more": "M4.5 12a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0zM10.5 12a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0zM16.5 12a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0z",
  "type": "M4 7V5h11v2M9.5 5v14M7 19h5M14 12v-1.5h7V12M17.5 10.5V19M16 19h3",
  "sliders": "M4 7h10M18 7h2M4 17h4M12 17h8M14 5v4M8 15v4",
  "maximize": "M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5",
  "titles": "M5 6h14M5 10h14M5 14h14M5 18h14",
  "compact": "M5 6.5h14M5 10h9M5 14.5h14M5 18h9",
  "previews": "M4 6h9M4 10h9M4 14h9M4 18h6M16 6h4v6h-4z",
  "stack": "M12 4 3 8.5l9 4.5 9-4.5zM3 12.5l9 4.5 9-4.5M3 16.5l9 4.5 9-4.5",
  "sun": "M12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zM12 2.5v2M12 19.5v2M4.6 4.6 6 6M18 18l1.4 1.4M2.5 12h2M19.5 12h2M4.6 19.4 6 18M18 6l1.4-1.4",
  "moon": "M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z",
  "x": "M6 6l12 12M18 6 6 18",
  "refresh": "M20 11a8 8 0 0 0-14.6-4.5L4 8M4 4v4h4M4 13a8 8 0 0 0 14.6 4.5L20 16M20 20v-4h-4",
  "play": "M8 5.5v13l10.5-6.5z",
  "alert": "M12 3.5 2.5 20h19zM12 10v4.5M12 17.5h.01",
  "wifiOff": "M3 3l18 18M8.5 16.5a5 5 0 0 1 7 0M5 12.6a10 10 0 0 1 5-2.5M19 12.6a10 10 0 0 0-2.6-1.8M2 9a15 15 0 0 1 4.4-2.8M22 9a15 15 0 0 0-9.4-3.9M12 20h.01",
  "folder": "M3.5 6.5h6l2 2h9v10h-17z",
  "pencil": "M14.5 5.5l4 4M4 20l1-5L15.5 4.5l4 4L9 19z",
  "minusC": "M12 20.5a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17zM8 12h8",
  "upload": "M12 15V4M7 9l5-5 5 5M4 15v4.5h16V15",
  "download": "M12 4v11M7 10l5 5 5-5M4 15v4.5h16V15",
  "link": "M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1",
  "eye": "M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12zM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6z",
  "kbd": "M3 6.5h18v11H3zM7 10h.01M11 10h.01M15 10h.01M7 14h10",
  "info": "M12 20.5a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17zM12 11v5.5M12 7.5h.01",
  "monitor": "M3.5 5h17v11h-17zM9 20h6M12 16v4",
  "rss": "M5 19h.01M5 12a7 7 0 0 1 7 7M5 5a14 14 0 0 1 14 14",
  "swipe": "M3 7.5h10M10 4.5l3 3-3 3M17 12.5H7M10 9.5l-3 3 3 3",
  "menu": "M4 7h16M4 12h16M4 17h16",
  "back": "M15 5l-7 7 7 7",
  "aa": "M3 18 7.5 6h1L13 18M4.5 14h7M15 18v-5.5a2.5 2.5 0 0 1 5 0V18M15 15h5",
  "pause": "M7 5.5h3.5v13H7zM13.5 5.5H17v13h-3.5z",
  "listen": "M4 15.5V12a8 8 0 0 1 16 0v3.5M4 15h3.5v5.5H5.5A1.5 1.5 0 0 1 4 19zM20 15h-3.5v5.5h2A1.5 1.5 0 0 0 20 19z",
  "replay": "M3.5 12a8.5 8.5 0 1 0 2.7-6.2M3.5 4v4.8h4.8",
  "skipNext": "M6 6l9 6-9 6zM18.5 6v12"
};
export const FILLED = new Set(["more","bookmarkF","play","pause"]);
